/* eslint-disable no-param-reassign */
function urlConvert(url: string, was: string[], is: string[], sensorIds?: string): string {
    was.forEach((val, idx) => {
        url = url.replace(`/${val}/`, `/${is[idx]}/`);
    });

    if (sensorIds) {
        url += `?sensors=${sensorIds}`;
    }

    return url;
}

export default urlConvert;
